import { ImageService } from "@DavisDigital/davisdigitalfrontend.module";
import * as IDavis from '@DavisDigital/interfaces';

class ImageCollectionCopyModalController {
    
    public isLoading = false;
    public collectionBackgroundColors;
    public imageSet;
	public title: string = "";
	// @ngInject
	constructor(
		public imageService   : ImageService,
		public ModalService
	){}
	
	public $onInit = () => {
		
	}

	public save = () =>{
		
		this.isLoading = true;
		
		if( this.isLoading && this.title != "") {
			let imageSet: IDavis.IImageSet = {
				title: this.title,
				imageSetID: this.imageSet.imageSetID,
			};
			
			this.imageService.copyImageSet(imageSet).then(
				(response)=>{
					console.log('respy', response);
				},
				(reason) =>{
				  window.location.href = "/images?currentPage=1&tab=mycollections&imagesetid="+reason.data.imageSetID;
				}
			).finally(()=>{
				this.isLoading = false;
				this.close();
			})
		}
	}
	
	public close = () =>{
		this.ModalService.closeModals();
	}
}
    

class ImageCollectionCopyModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
		close:'=',
		collectionBackgroundColors: '=?',
		imageSet:'=?'
	};

	public controller = ImageCollectionCopyModalController;
	public controllerAs = 'imageCollectionCopyModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/image-collection-copy-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCollectionCopyModal };
